import { useCallback } from 'react';

import FullScreenBanner from '@goshippo/libraries/shared/FullScreenBanner';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useBillingAccount } from '~/src/hooks/useBillingAccount';
import { useGlobalAlerts } from '~/src/hooks/useGlobalAlerts';
import { useSnackbar } from '~/src/hooks/useSnackbar';
import { useUserAccount } from '~/src/hooks/useUserAccount';

export const FullScreenBannerWrapper = () => {
  useGlobalAlerts();

  const { t } = useTranslation('', { keyPrefix: 'fullScreenBanner' });
  const navigate = useNavigate();
  const { show } = useSnackbar();
  const billingAccountQuery = useBillingAccount();
  const { data, resendEmailVerification } = useUserAccount();

  const handleResendEmailVerification = () =>
    resendEmailVerification(undefined, {
      onError: (error) => {
        show({
          autoHideDuration: 3000,
          message: t('verifyEmail.snackbar.error', {
            message: error.message || 'Request Failed',
          }),
          variant: 'error',
        });
      },
      onSuccess: () => {
        show({
          autoHideDuration: 3000,
          message: t('verifyEmail.snackbar.success'),
          variant: 'success',
        });
      },
    });

  const handleGoToBilling = useCallback(() => {
    navigate('/account/billing');
  }, [navigate]);

  const isGracePeriodExpired = billingAccountQuery.data?.grace_period_end_timestamp
    ? new Date(billingAccountQuery.data.grace_period_end_timestamp) < new Date()
    : false;

  if (data?.requiresEmailVerification) {
    return (
      <FullScreenBanner
        actionFn={handleResendEmailVerification}
        actionLabel={t('verifyEmail.actionLabel')}
        bannerType="notice"
        message={t('verifyEmail.message')}
      />
    );
  } else if (data?.hasFailedPayment || isGracePeriodExpired) {
    const message = isGracePeriodExpired
      ? `${t('pastDueInvoices.gracePeriod')} ${t('pastDueInvoices.message')}`
      : t('pastDueInvoices.message');

    return (
      <FullScreenBanner
        actionFn={handleGoToBilling}
        actionLabel={t('pastDueInvoices.actionLabel')}
        bannerType="notice"
        message={message}
      />
    );
  }
  return null;
};
